import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { config } from '../config';
import { UNKNOWN_TEAM } from './constants';
var transformTeam = function transformTeam(team, id) {
  return {
    id: id,
    name: team.displayName,
    type: 'team',
    avatarUrl: team.smallAvatarImageUrl
  };
};
var hydrateTeamFromLegion = function hydrateTeamFromLegion(request) {
  var url = "".concat(config.getTeamsUrl(request.baseUrl), "/").concat(request.id);
  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'content-type': 'application/json'
    }
  }).then(function (response) {
    if (response.status === 200) {
      return response.json();
    }
    return Promise.reject({
      message: "error calling Legion, statusCode=".concat(response.status, ", statusText=").concat(response.statusText)
    });
  }).then(function (response) {
    return transformTeam(response, request.id);
  }).catch(function () {
    return _objectSpread(_objectSpread({}, UNKNOWN_TEAM), {}, {
      // on network error, return original team with label 'Unknown'
      id: request.id
    });
  });
};
export default hydrateTeamFromLegion;